/**
 * A billing address is "complete" once every REQUIRED field is filled.
 *
 * `address2` (House/Apt./Suite) is OPTIONAL — the identity flow's own
 * BillingForm gate skips it (`user-identity-flow.tsx` `hasBillingInfo` filters
 * `address2` out before checking), so a person can save a valid address with it
 * blank. The success screen used `Object.values(address).every(Boolean)`, which
 * counts `address2`, so a saved-but-blank `address2` read as "still incomplete":
 * it kept offering "Add billing info", which saved again and returned to the
 * same screen — the update-billing loop. Checking only the required fields, the
 * same set the form enforces, keeps the two in agreement.
 */
export const REQUIRED_BILLING_FIELDS = [
	'address1',
	'country',
	'state',
	'city',
	'zip',
] as const;

export const isBillingAddressComplete = (
	address?: Record<string, unknown> | null
): boolean => {
	if (!address) return false;
	return REQUIRED_BILLING_FIELDS.every(key => {
		const value = address[key];
		return typeof value === 'string' ? value.trim() !== '' : !!value;
	});
};
